import { Button } from '@hivebrite/design-system/Button';

const DeleteImageSource = ({ item, onChange, settingKey, content }) => {
  const handleButtonClick = () => {
    onChange({
      id: item.id,
      settingKey,
      value: '',
    });
  };

  return (
    <Button
      fontFamily="Inter"
      mb={4}
      onClick={handleButtonClick}
      variant="primary"
      width="100%"
    >
      {content}
    </Button>
  );
};

export default DeleteImageSource;

DeleteImageSource.defaultProps = {
  isImage: true,
  content: s__('Builder|Delete image'),
};
